import Container from "./Container"
export default function Dashboard(){
    return(
        <Container>
        </Container>
    )
}